module.exports = __webpack_public_path__ + "img/blueTran.34ad370b.png";